import axios from 'axios';

import { UserProfilePublic } from '../user/userTypes';
const URL = '/api/v2/auth/me';
export async function getUserProfileData(): Promise<UserProfilePublic | null> {
    try {
        const { data } = await axios.get(URL);
        if (!data || data.status === 'unauthenticated' || !data.user) {
            return null;
        }

        return data.user;
    } catch {
        return null;
    }
}
